export const env = {
    //env: 'local'
    env: 'dev' // QAJ 8/29/24 Updated environment to dev
};
